const theme = {
    palette: {
        white: '#ffffff',
        primary: '#cfb995',
        lightDark: '#5e5e5e',
        gray: '#303030',
        dark: '#2e312f',
        lightWhite: '#f9f9f9',
        white2: '#efefef'
    },
    mediaQueries:{
        mobile: '667px',//"only screen and (max-width: 667px)",
        //tablet': "only screen and (min-width: 668px) and (max-width: $size__site_content_width)",
    },
    category: [
         '#ff5b5a',
         '#ff925a',
        '#ffbc5e',
         '#ffdf5c',
        '#91e25f',
        '#56e68f',
         '#57dbe7',
         '#73d2de',
        '#218380',
         '#a2c7e5',
         '#a2c7e5',
         '#d6ca98',
        '#6153cc',
        '#44ffd1',
        '#60992d',
         '#ecdd7b',
    ]

}

export default theme;